import { genComponentEl } from '@/utils/utils';
import Contextmenu from '../index.vue';

/**
 * 弹出右键菜单
 * @example 使用示例:
 * popContextmenu({
 *    x: event.clientX,
 *    y: event.clientY,
 *    data: { sn: data.sn, deviceType: data.deviceType },
 *    menu: [
 *      {
 *        text: '查看设备详情',
 *        event: ({ sn, deviceType }) => {
 *          this.$router.push({ name: 'Realdata', params: { sn, deviceType } });
 *        }
 *      },
 *      {
 *        text: '新窗口查看设备详情',
 *        event: ({ sn, deviceType }) => {
 *          windowOpen({ name: 'Realdata', params: { sn, deviceType } }, this.sn);
 *        }
 *      }
 *    ]
 *  });
 * @param {{ x:number, y: number, appendToBody?: boolean, container?: HTMLElement|string, menu: {text:string, event: (...rest) => void}[], data: any }} data
 */
export function popContextmenu(data) {
  genComponentEl(Contextmenu, data);
}
